"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFunnelState = exports.useFunnelActions = exports.default = exports.FunnelWrapper = exports.FunnelStateContext = exports.FunnelActionsContext = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = _interopRequireWildcard(require("../../utils/useOurTranslation"));

var _NoDataOverlay = _interopRequireDefault(require("../NoDataOverlay"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _SectionSeparator = require("../SectionSeparator");

var _reactSwipeableViewsUtils = require("react-swipeable-views-utils");

var _analytics = require("@jobmatchme/frontend-analytics/es/analytics");

var _useExcludeFromSsr = require("@jobmatchme/library-utils/es/hooks/useExcludeFromSsr");

var _ConfigProvider = require("../../provider/ConfigProvider");

var _FooterNavigation = _interopRequireDefault(require("../FooterNavigation"));

var _SelectComponent = _interopRequireDefault(require("../SelectComponent"));

var _ViewContainer = _interopRequireDefault(require("../ViewContainer"));

var _FunnelHeader = _interopRequireDefault(require("../FunnelHeader/"));

var _LegalFooter = _interopRequireDefault(require("../LegalFooter"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _Onboarding = require("@jobmatchme/ui/es/components/styleguide/Onboarding");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["funnelTarget"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var evaluateConditions = function evaluateConditions(conditions, profile) {
  var conditionsMet = true;
  conditions && conditions.forEach(function (condition) {
    switch (condition.relation) {
      case 'EQUALS':
        {
          if (!(condition.value === profile[condition.valueName].value)) {
            conditionsMet = false;
          }

          break;
        }

      case 'NOT_EQUALS':
        {
          if (condition.value === profile[condition.valueName].value) {
            conditionsMet = false;
          }

          break;
        }

      case 'GREATER_THAN':
        {
          if (condition.value < profile[condition.valueName].value) {
            conditionsMet = false;
          }

          break;
        }

      case 'LESS_THAN':
        {
          if (condition.value > profile[condition.valueName].value) {
            conditionsMet = false;
          }

          break;
        }

      case 'CONTAINS':
        {
          if (profile[condition.valueName].value.indexOf(condition.value) < 0) {
            conditionsMet = false;
          }

          break;
        }

      case 'NOT_CONTAINS':
        {
          if (profile[condition.valueName].value.indexOf(condition.value) >= 0) {
            conditionsMet = false;
          }

          break;
        }

      default:
        {
          throw new Error("Undefined relation in condition: ".concat(condition));
        }
    }
  });
  return conditionsMet;
};

var VirtualizeSwipeableViews = (0, _reactSwipeableViewsUtils.virtualize)(_reactSwipeableViews.default); // This funciton will use the config to generate the views that will be shown in the funnel.
// insert new component types here

var generateSteps = function generateSteps(config, profile, headerMenu) {
  var generateFor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'funnel';
  var startScreen = arguments.length > 4 ? arguments[4] : undefined;
  var steps = [];
  var sectionSeparatorPositions = [];
  var funnelConfig = (config || {})[generateFor] || [];
  funnelConfig.forEach(function (funnelSection, stepCount) {
    var totalStepsNumber = config && config.funnel && config.funnel[0] && config.funnel[1] ? config.funnel[0].steps.length + config.funnel[1].steps.length + 1 : 0;
    steps.push( /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      // Yes, this is a prop on a div. Seems to be needed for the analytics hook. To be refactored!
      // @ts-ignore
      noCount: true,
      config: {
        requiresProfileData: funnelSection.entryRequiresProfileData
      },
      children: [headerMenu ? headerMenu : '', startScreen && stepCount === 0 ? startScreen : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionSeparator.SectionSeparator, {
        config: {
          currentSection: stepCount + 1,
          maxSections: funnelConfig.length,
          maxSteps: steps.length,
          discriminator: config === null || config === void 0 ? void 0 : config.discriminator,
          target: config === null || config === void 0 ? void 0 : config.target,
          translations: funnelSection.translations
        },
        totalStepsNumber: totalStepsNumber
      }, "funnelSeparator".concat(stepCount))]
    }, "funnelSeparator_".concat(stepCount)));
    sectionSeparatorPositions.push(steps.length - 1);
    funnelSection.steps.forEach(function (stepKey) {
      if (!(config !== null && config !== void 0 && config.componentConfigurations[stepKey.componentConfiguration])) {
        throw Error("Undefined component configuration ".concat(stepKey.componentConfiguration));
      }

      var stepConfig = (0, _extends2.default)({}, config === null || config === void 0 ? void 0 : config.componentConfigurations[stepKey.componentConfiguration], {
        // If the mandatory field is configured at a higher level, we consider it as an override to the default configuration
        mandatory: stepKey.mandatory !== undefined ? stepKey.mandatory : config.componentConfigurations[stepKey.componentConfiguration].mandatory
      });

      if (evaluateConditions(stepConfig.conditions, profile)) {
        steps.push((0, _SelectComponent.default)({
          componentConfiguration: stepConfig
        }));
      }
    });
  });
  return [steps, sectionSeparatorPositions];
};

var FunnelActionsContext = /*#__PURE__*/_react.default.createContext({
  next: function next() {},
  skip: function skip() {}
});

exports.FunnelActionsContext = FunnelActionsContext;

var useFunnelActions = function useFunnelActions() {
  return (0, _react.useContext)(FunnelActionsContext);
};

exports.useFunnelActions = useFunnelActions;

var FunnelStateContext = /*#__PURE__*/_react.default.createContext({});

exports.FunnelStateContext = FunnelStateContext;

var useFunnelState = function useFunnelState() {
  return (0, _react.useContext)(FunnelStateContext);
};

exports.useFunnelState = useFunnelState;

/**
 * Main entry point for the configurable funnel.
 * @param {Context} configurationContext - The context, that holds the applications profile configuration
 * @param {String} progressStepperVariant - The variant of the used progress stepper. Eigther "text" or "default"
 * @param {React.Node} headerMenu - The menu to optionally show in the header
 * @param {React.Node} actionButton - The button to optionally show in the header
 * @param {void} onComplete - Action to execute, once the funnel is completed and the user clicks on the last "next" button
 * @param {void} onCancel - Action to execute, when the funnel is aborted (When the user clicks back on the first slide). If this function is not defined, the back button will be hidden on the first accessible slide
 * @param {String} configKey - The key for the funnel definition in the config to use for creating the funnel instance
 * @param {React.Node} startScreen - An optional start screen to display before the first slide of the funnel
 * @param {Array} Optional applicationRoutes array for the funnel
 */
var Funnel = function Funnel(_ref) {
  var _steps$index$props$co;

  var onCancel = _ref.onCancel,
      onComplete = _ref.onComplete,
      headerMenu = _ref.headerMenu,
      startScreen = _ref.startScreen,
      actionButton = _ref.actionButton,
      applicationRoutes = _ref.applicationRoutes,
      _ref$configKey = _ref.configKey,
      configKey = _ref$configKey === void 0 ? 'funnel' : _ref$configKey,
      progressStepperVariant = _ref.progressStepperVariant,
      _ref$configurationCon = _ref.configurationContext,
      configurationContext = _ref$configurationCon === void 0 ? _ConfigProvider.ConfigurationContext : _ref$configurationCon;
  var exclude = (0, _useExcludeFromSsr.useExcludeFromSsr)();
  var t = (0, _useOurTranslation.default)("profile-components:Funnel");

  var _useContext = (0, _react.useContext)(configurationContext),
      config = _useContext.config;

  var configDiscriminator = (config === null || config === void 0 ? void 0 : config.discriminator) || 'jmm';

  var _useContext2 = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      isFunnelCompleted = _useContext2.isFunnelCompleted,
      getPlainProfile = _useContext2.getPlainProfile,
      cleanup = _useContext2.cleanup,
      track = _useContext2.track;

  var profile = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      noData = _useState2[0],
      setNoData = _useState2[1];

  var _useState3 = (0, _react.useState)(!!startScreen ? 0 : 1),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      index = _useState4[0],
      setIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      uiLock = _useState6[0],
      setUiLock = _useState6[1]; // If the index changes (e.g. a back navigation) release the ui lock


  (0, _react.useEffect)(function () {
    setUiLock(false);
  }, [index]);

  var _generateSteps = generateSteps(config, profile, headerMenu, configKey, startScreen),
      _generateSteps2 = (0, _slicedToArray2.default)(_generateSteps, 2),
      initialSteps = _generateSteps2[0],
      initialSectionSeparatorPositions = _generateSteps2[1];

  var _useState7 = (0, _react.useState)(initialSteps),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      steps = _useState8[0],
      setSteps = _useState8[1];

  var _useState9 = (0, _react.useState)(initialSectionSeparatorPositions),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      sectionSeparatorPositions = _useState10[0],
      setSectionSeparatorPositions = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      showedSteps = _useState12[0],
      setShowedSteps = _useState12[1];

  var target = config === null || config === void 0 ? void 0 : config.target;
  var valueIsSet = (0, _react.useCallback)(function () {
    var config = steps[index].props.config;
    var state = profile[config.valueName]; // In case we have a specific empty check

    if (config.isSet) return config.isSet(state); // In case we have a divider section or selecting a config

    if (!config.valueName) return true;

    if (!profile[config.valueName]) {
      throw Error("Missing context state for key \"".concat(config.valueName, "\"!"));
    }

    return Array.isArray(state.touched) ? state.touched.includes(config.identifier || config.valueName) : state.touched;
  }, [index, profile, steps]); // Handling the education tooltips

  var compT = (0, _useOurTranslation.useComponentTranslation)(steps[index].props.config);
  (0, _Onboarding.useTooltipRegistration)(steps[index].props.config.educationTooltip && {
    target: (_steps$index$props$co = steps[index].props.config.educationTooltip) === null || _steps$index$props$co === void 0 ? void 0 : _steps$index$props$co.target,
    content: compT(steps[index].props.config.educationTooltip.content),
    position: 1,
    isFixed: true,
    offset: steps[index].props.config.educationTooltip.offset,
    placement: steps[index].props.config.educationTooltip.placement
  }, !steps[index].props.config.educationTooltip); // Display if we reach the correct index

  var _useContext3 = (0, _react.useContext)(_Onboarding.OnboardingContext),
      runOnboarding = _useContext3.runOnboarding,
      resetOnboarding = _useContext3.resetOnboarding;

  var onboardingTimeoutRef = (0, _react.useRef)({}); // Reset onboarding if value is set

  (0, _react.useEffect)(function () {
    if (valueIsSet()) {
      clearTimeout(onboardingTimeoutRef.current);
      resetOnboarding();
    }
  }, [valueIsSet, resetOnboarding]);

  var handleNextClick = function handleNextClick() {
    next();
  };

  var next = (0, _react.useCallback)(function () {
    var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var forceNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var newIndex = index + 1 + (Number.isInteger(skip) ? skip : 0);

    if (newIndex < steps.length) {
      // In Funnel
      if ((config === null || config === void 0 ? void 0 : config.target) !== 'bc' && steps[newIndex] && steps[newIndex].props.config.requiresProfileData && !isFunnelCompleted && !forceNext) {
        // Next step requires data - jump back
        setNoData(true);
      } else {
        // Go ahead
        setIndex(newIndex); // Clear active education timer

        clearTimeout(onboardingTimeoutRef.current); // Start time for education tooltips if defined

        if (steps[newIndex].props.config.educationTooltip && (config === null || config === void 0 ? void 0 : config.target) !== 'bc' && steps[newIndex].props.config.educationTooltip.delay > 1) {
          onboardingTimeoutRef.current = setTimeout(runOnboarding, steps[newIndex].props.config.educationTooltip.delay);
        }
      }
    } else {
      // End of funnel
      if (!(config || {}).allowEmpty && !isFunnelCompleted && !forceNext) {
        // No Data makes no sense - jump back
        setNoData(true);
      } else {
        // Funnel has completed. Execute action or redirect
        if (onComplete) {
          onComplete(getPlainProfile(), cleanup);
          setUiLock(true);
        }
      }
    }
  }, [index, steps, config, cleanup, isFunnelCompleted, getPlainProfile, runOnboarding, onComplete]);
  var back = (0, _react.useCallback)(function () {
    // Clear active education timer
    clearTimeout(onboardingTimeoutRef.current);
    if (index > 1 || index > 0 && !!startScreen) setIndex(index - 1);else if (onCancel) onCancel();
  }, [index, onCancel, startScreen]);
  var skip = (0, _react.useCallback)(function (section) {
    var configFunnel = (config === null || config === void 0 ? void 0 : config.funnel) || [];
    var skipSteps = configFunnel.slice(0, section - 1).reduce(function (accumulator, currentValue) {
      return accumulator + currentValue.steps.length;
    }, 1);
    next(skipSteps);
  }, [next, config === null || config === void 0 ? void 0 : config.funnel]);
  var funnelActions = (0, _react.useMemo)(function () {
    return {
      next: next,
      skip: skip
    };
  }, [next, skip]);
  (0, _react.useEffect)(function () {
    var _generateSteps3 = generateSteps(config, profile, headerMenu, configKey, startScreen),
        _generateSteps4 = (0, _slicedToArray2.default)(_generateSteps3, 2),
        newSteps = _generateSteps4[0],
        newSectionSeparatorPositions = _generateSteps4[1];

    if (newSteps.length !== steps.length) {
      setSectionSeparatorPositions(newSectionSeparatorPositions);
    }

    setSteps(newSteps);
  }, [config, configKey, profile, headerMenu, startScreen, steps.length]); // Disable Tab key, to prevent skipping of slides

  (0, _react.useEffect)(function () {
    var onTabKey = function onTabKey(event) {
      if (event.keyCode === 9) {
        event.preventDefault();
        return false;
      }
    };

    document.addEventListener('keydown', onTabKey);
    return function () {
      document.removeEventListener('keydown', onTabKey);
    };
  }, []);
  (0, _react.useEffect)(function () {
    // Send Funnel browsing statistics to GTAG & tracking backend
    var getStepName = function getStepName() {
      var _steps$index, _steps$index$key;

      var stepNumber = (((_steps$index = steps[index]) === null || _steps$index === void 0 ? void 0 : (_steps$index$key = _steps$index.key) === null || _steps$index$key === void 0 ? void 0 : _steps$index$key.toString()) || '').replace('funnelSeparatorDiv', '');
      return "sectionSeparator ".concat(configKey, " ").concat(Number.isInteger(parseInt(stepNumber)) ? parseInt(stepNumber) + 1 : 3, "/3");
    };

    if (index < steps.length) {
      var stepName = '';

      if (steps[index].props.config.valueName) {
        if (steps[index].props.config.valueName === 'diagnostic') {
          stepName = "diagnostic position ".concat(steps[index].props.config.position, " ").concat(steps[index].props.config.identifier);
        } else if (steps[index].props.config.valueType === 'DescriptionString') {
          stepName = steps[index].props.config.identifier;
        } else {
          stepName = steps[index].props.config.valueName;
        }
      } else {
        stepName = getStepName();
      } // Check doubled event sending


      if (showedSteps.indexOf(stepName + index) === -1) {
        // Send Events to GA
        (0, _analytics.trackPkFunnelStepsWithDiscriminator)({
          step: stepName,
          discriminator: configDiscriminator,
          configKey: configKey,
          target: target
        });
        setShowedSteps([].concat((0, _toConsumableArray2.default)(showedSteps), [stepName + index])); // Send Events to tracking backend

        track('funnelStep', {
          target: target,
          step: stepName,
          discriminator: configDiscriminator
        });
      }
    }
  }, [configDiscriminator, index, steps, showedSteps, configKey, target, startScreen, track]);

  var goBackToStart = function goBackToStart() {
    setNoData(false);
    setIndex(0);
  };

  var closeOverlay = function closeOverlay() {
    setNoData(false);
    next(0, true);
  };

  var isIE = function isIE() {
    if (typeof window !== 'undefined') {
      var ua = window.navigator.userAgent;
      var msie10 = ua.indexOf('MSIE');
      var msie11 = ua.indexOf('rv:11.0');

      if (msie10 > 0 || msie11 > 0) {
        // If Internet Explorer, return true
        return true;
      } // If another browser, return false
      else {
        return false;
      }
    } else {
      return false;
    }
  };

  var userCanContinue = function userCanContinue() {
    if (steps[index].props.config.mandatory) {
      return valueIsSet();
    } else {
      return true;
    }
  }; // Separator Pages should be excluded from the calculation


  var stepsLength = function stepsLength(arr) {
    var counter = 0;

    if (steps.length > 0) {
      for (var i = 0; i < arr.length; i++) {
        if (!arr[i].key.includes(0)) counter++;
      }

      return counter;
    } else return 0;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FunnelHeader.default, {
      index: index,
      stepsLength: stepsLength(steps),
      sectionSeparatorPositions: sectionSeparatorPositions,
      progressStepperVariant: progressStepperVariant,
      discriminator: config === null || config === void 0 ? void 0 : config.discriminator,
      actionButton: actionButton,
      target: config === null || config === void 0 ? void 0 : config.target
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelWrapper, {
      children: exclude( /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelActionsContext.Provider, {
          value: funnelActions,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(FunnelStateContext.Provider, {
            value: index,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ViewContainer.default, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(VirtualizeSwipeableViews, {
                axis: "x",
                id: "viewBody",
                index: index,
                disabled: true,
                resistance: false,
                animateHeight: false,
                overscanSlideAfter: 2,
                overscanSlideBefore: 1,
                onChangeIndex: setIndex,
                animateTransitions: !isIE(),
                slideRenderer: function slideRenderer(_ref2) {
                  var index = _ref2.index;
                  return steps[index];
                },
                disableLazyLoading: false,
                ignoreNativeScroll: false,
                slideCount: steps.length
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LegalFooter.default, {
                applicationRoutes: applicationRoutes
              })]
            })
          })
        }), !((steps[index].props || {}).config || {}).hideNavigation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterNavigation.default, {
          highlightRightButton: valueIsSet(),
          rightButtonDisabled: !userCanContinue() || uiLock,
          hideLeftButton: !onCancel && (!!startScreen && index < 1 || !startScreen && index < 2),
          onRightButtonClick: handleNextClick,
          onLeftButtonClick: back,
          buttonRightText: t('next'),
          buttonLeftText: t('back')
        })]
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoDataOverlay.default, {
      open: noData,
      onAccept: goBackToStart,
      onClose: closeOverlay,
      variant: config === null || config === void 0 ? void 0 : config.target
    })]
  });
};

var FunnelWrapper = /*#__PURE__*/(0, _react.memo)(function (_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: "funnel",
    className: _styleModule.default.funnel,
    children: children
  });
});
exports.FunnelWrapper = FunnelWrapper;

var WrappedFunnel = function WrappedFunnel(_ref4) {
  var funnelTarget = _ref4.funnelTarget,
      props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Onboarding.OnboardingProvider, {
    funnelTarget: funnelTarget,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Funnel, (0, _extends2.default)({}, props))
  });
};

var _default = /*#__PURE__*/_react.default.memo(WrappedFunnel);

exports.default = _default;